import React, {useEffect} from "react";
import "./TrainersPanel.sass"
import InformationBlock from "../../../_containers/infoblock/InformationBlock";
import TrainersItem from "./TrainersItem";
import {ReactComponent as Mental} from "../../../images/release/trainers/mental.svg";
import {ReactComponent as Abacus} from "../../../images/release/trainers/abacus.svg";
import {ReactComponent as Cards} from "../../../images/release/trainers/cards.svg";
import {ABACUS_PAGE, MENTAL_TRAINING_PAGE} from "../../../common/links";
import {useDispatch, useSelector} from "react-redux";
import {ROLE_STUDENT} from "../../../common/roles";
import {IDLE, LOADING, SUCCESS} from "../../../common/statuses";
import {getAllStudentHomework} from "../../../_actions/student/hw/hwService";
import Spinner from "../../../pages/common/anonymous/Spinner";
import _ from "lodash";
import {useSnackbar} from "notistack";
import {clearHWState} from "../../../_actions/student/hw/hwReducer";

export default function TrainersPanel() {

    const {current} = useSelector(state => state.auth);
    const {mental, status} = useSelector(state => state.hw.courses)

    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
            if (status === IDLE && current.role === ROLE_STUDENT) {
                dispatch(getAllStudentHomework())
            }

            // todo: Раскоментировать, когда нужно будет сделать ограничение по балансу
            // if (status === SUCCESS) {
            //     if (current.balance < 0) {
            //         enqueueSnackbar("Вам недоступны тренажёры т.к. у вас отрицательный баланс", {variant: "error"})
            //     } else {
            //         const {mental} = data;
            //         if (!_.isEmpty(mental) && mental.find(hw => !hw.isFinished)) {
            //             enqueueSnackbar("Выполни домашнее задание и тебе будут доступны игры", {variant: "info"})
            //         }
            //     }
            // }

            if (status === SUCCESS) {
                if (!_.isEmpty(mental.content) && mental.content.find(hw => !hw.isFinished)) {
                    enqueueSnackbar("Выполни домашнее задание и тебе будут доступны игры", {variant: "info"})
                }
            }
        }, [status]
    )
    useEffect(() => {
        return () => dispatch(clearHWState())
    }, [])

    if (current.role === ROLE_STUDENT && (status === IDLE || status === LOADING)) {
        return <Spinner/>
    }

    // todo: Раскоментировать, когда нужно будет сделать ограничение по балансу
    // const disabled = current.role === ROLE_STUDENT && current.balance < 0;
    const disabled = false;

    const isDisabledGames = () => {
        if (current.role === ROLE_STUDENT) {
            // todo: Раскоментировать, когда нужно будет сделать ограничение по балансу
            // if (current.balance < 0) {
            //     return true
            // }

            if (_.isEmpty(mental.content)) {
                return false;
            } else {
                if (mental.content.find(hw => !hw.isFinished)) {
                    return true;
                }
            }
        }

        return false;
    }

    return (
        <InformationBlock align="left">
            <div className="TrainersPanel-wrapper">
                <TrainersItem disabled={disabled}
                              link={MENTAL_TRAINING_PAGE}
                              Icon={Mental}
                              title="Ментальная арифметика"/>
                <TrainersItem disabled={disabled}
                              link={ABACUS_PAGE}
                              Icon={Abacus}
                              title="Абакус"/>
                <TrainersItem disabled={isDisabledGames()}
                              link="/home/game/card"
                              Icon={Cards}
                              title="Игра Пары"/>
                <div className="TrainersPanel-dev-block">
                    <div>
                        Тренажёр в разработке
                    </div>
                </div>
            </div>
        </InformationBlock>
    )
}